<template>
    <!--section  --> 
    <section class="scroll-con-sec gray-bg" id="sec5">
        <div class="container">
            <div class="section-title fl-wrap">
                <h2>Clients <strong>And Testimonials</strong></h2>
                <p>{{ sectionSubtitle }}</p>
                <div class="sec-title_dec"></div>
            </div>
            <div class="testimonilas-carousel-wrap fl-wrap">
                <div class="testimonilas-carousel">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <!--testi-item-->
                            <div class="swiper-slide" v-for="(testimonial, index) in testimonials" :key="testimonial.id">
                                <div class="testi-item fl-wrap">
                                    <div class="testi-avatar">
                                        <img :src="testimonial.avatar" :alt="testimonial.name">
                                    </div>
                                    <div class="testimonilas-text fl-wrap">
                                        <h3>{{ testimonial.name }}</h3>
                                        <p>"{{ testimonial.content }}"</p>
                                        <a :href="testimonial.link" class="testi-link" target="_blank">
                                            {{ testimonial.source }}
                                        </a>
                                        <span class="testi-number">{{ String(index + 1).padStart(2, '0') }}.</span>
                                    </div>
                                </div>
                            </div>
                            <!--testi-item end-->
                        </div>
                    </div>
                </div>
                <div class="tc-pagination"></div>
                <div class="tc-button_wrap">
                    <div class="tc-button tc-button-prev">
                        <i class="fal fa-angle-left"></i>
                    </div>
                    <div class="tc-button tc-button-next">
                        <i class="fal fa-angle-right"></i>
                    </div>
                </div>
            </div>
            <!-- client-list -->
            <div class="fl-wrap client-list" v-if="clients.length">
                <ul>
                    <li v-for="client in clients" :key="client.id">
                        <a :href="client.website || '#'" target="_blank">
                            <img :src="client.logo" :alt="client.name">
                        </a>
                    </li>
                </ul>
                <!-- client-list end-->
            </div>
        </div>
        <div class="section-number"><span>0</span>5<strong>.</strong></div>
    </section>
    <!--section end-->
</template>

<script>
export default {
    name: 'TestimonialsSection',
    data() {
        return {
            sectionSubtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque.',
            testimonials: [],
            clients: [],
            testimonialsSwiper: null
        }
    },
    async mounted() {
        await this.loadTestimonials()
        await this.loadClients()
        
        // Initialize testimonials carousel after data is loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.initTestimonialsCarousel()
            }, 100)
        })
    },
    beforeUnmount() {
        // Clean up Swiper instance
        const $ = window.jQuery
        if ($ && this.testimonialsSwiper) {
            this.testimonialsSwiper.destroy(true, true)
            this.testimonialsSwiper = null
        }
    },
    methods: {
        async loadTestimonials() {
            try {
                const response = await this.$api.get('public/content/testimonials')
                if (response.data && response.data.data) {
                    this.testimonials = response.data.data.map(testimonial => ({
                        id: testimonial.id,
                        name: testimonial.title,
                        content: testimonial.description,
                        avatar: testimonial.featured_image,
                        source: 'Via Website',
                        link: '#'
                    }))
                    console.log('✅ Loaded', this.testimonials.length, 'testimonials')
                }
            } catch (error) {
                console.error('❌ Failed to load testimonials:', error)
                this.testimonials = []
            }
        },
        
        async loadClients() {
            try {
                const response = await this.$api.get('public/content/clients')
                if (response.data && response.data.data) {
                    this.clients = response.data.data.map(client => ({
                        id: client.id,
                        name: client.title,
                        logo: client.featured_image,
                        website: '#'
                    }))
                    console.log('✅ Loaded', this.clients.length, 'clients')
                }
            } catch (error) {
                console.error('❌ Failed to load clients:', error)
                this.clients = []
            }
        },
        
        initTestimonialsCarousel() {
            if (this.testimonials.length === 0) return
            
            const $ = window.jQuery
            const Swiper = window.Swiper
            
            if (!$ || !Swiper) {
                console.error('❌ jQuery or Swiper not loaded')
                return
            }
            
            console.log('🎬 Initializing testimonials carousel...')
            
            this.testimonialsSwiper = new Swiper(".testimonilas-carousel .swiper-container", {
                preloadImages: false,
                slidesPerView: 2,
                spaceBetween: 10,
                loop: true,
                grabCursor: true,
                mousewheel: false,
                centeredSlides: false,
                pagination: {
                    el: '.tc-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.tc-button-next',
                    prevEl: '.tc-button-prev',
                },
                breakpoints: {
                    800: {
                        slidesPerView: 1,
                    },
                }
            })
            
            console.log('✅ Testimonials carousel initialized')
        }
    }
}
</script>

